import { morph } from '@theme/morph';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    document.addEventListener(
      'variant:update',
      this.updatePrice
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      'variant:update',
      this.updatePrice
    );
  }

  updatePrice = (event) => {
    const currentPrice =
      this.querySelector("[ref='priceContainer']");

    const newPrice =
      event.detail?.data?.html?.querySelector(
        "product-price [ref='priceContainer']"
      );

    if (currentPrice && newPrice) {
      morph(currentPrice, newPrice);
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}